// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mShE","questions":"styles_questions__3jl6c","footer":"styles_footer__TttPt"};